import {
	Component,
	OnInit,
	Input,
	ViewChild,
	ElementRef,
	HostListener,
	AfterViewInit,
	Output,
	EventEmitter,
	OnChanges,
	OnDestroy,
	SimpleChanges
} from '@angular/core';
import { environment } from '@environments/environment';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { BookingStep } from '@ibe/models/ui';
import { takeWhile, first } from 'rxjs/operators';
import { DailyCost } from '@ibe.models/daily-cost.model';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { BookedTrip } from '@ibe/models';
import { CURRENCY_UNITS, TRIP_TYPE_ROUND_TRIP_CODE, TRIP_TYPE_MULTICITY_CODE, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import * as _ from 'lodash';
import { INDRABookingAvailabilityService } from '@ibe.services/booking-availability.indra.service';
import { getCurrencySymbol } from '@angular/common';
import * as ListOffersActions from '@ibe/store/actions/list-offers.action';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { BookingService } from '@ibe.services/booking.tap.service';


@Component({
	selector: 'app-day-switcher',
	templateUrl: './day-switcher.indra.component.html',
	styleUrls: ['./day-switcher.component.scss']
})
export class INDRADaySwitcherComponent
	implements OnInit, AfterViewInit, OnDestroy, OnChanges {
	daysPrice$: Observable<Array<DailyCost[]>> = this.store.select(
		fromStore.getBookingStepsCostsPerDay
	);
	dailyCosts: Array<DailyCost[]>;
	bookingSteps$: Observable<BookingStep[]> = this.store.select(
		fromStore.getSelectedBookingSteps
	);
	bookingSteps: Array<BookingStep>;
	currentStep$: Observable<number> = this.store.select(
		fromStore.getSelectedBookingCurrentStep
	);
	bookAwardFlights$: Observable<boolean> = this.store.select(
		fromStore.getFlightsFilterBookAwardFlights
	);
	bookAwardFlights = false;
	booked_trip$: Observable<BookedTrip> = this.store.select(
		fromStore.getSelectedBookedTrip
	);
	booked_trip: BookedTrip;
	listOffers$: Observable<any> = this.store.select(
		fromStore.getListOffers
	);
	listOffers;
	flightFilter$: Observable<any> = this.store.select(fromStore.getFlightsFilterState);
	passengerTypeStudent;

	flightInformation$: Observable<any> = this.store.select(fromStore.getFlightInformation);
    flightInformation: any;

	outboundFlightInformation$: Observable<any> = this.store.select(fromStore.getOutboundFlightInformation);
    outboundFlightInformation: any;

	inboundFlightInformation$: Observable<any> = this.store.select(fromStore.getInboundFlightInformation);
    inboundFlightInformation: any;

	daysPrice = [];
	prices = [];
	selectedEntries = [];
	selectedIndex: number = 0;

	OPTIONS_DATE = { day: 'numeric', month: 'short' };
	DAYS_TO_SHOW = 7;
	MIDDLE_DAY_INDEX = Math.ceil(this.DAYS_TO_SHOW / 2);
	isAlive = true;

	hasPrices: boolean = true;

	@Input()
	navigate: boolean = false;

	@Input()
	selectedDate: Date;

	@Input()
	currentStep = 0;

	@Output()
	todayCheapest = new EventEmitter();

	@Output()
	dateChanged = new EventEmitter<string>();

	@ViewChild('daySwitcherContent') private daySwitcherContent: ElementRef;
	start: number;

	@Input()
	dateList = [];

	@Input()
	param;

	isLoading = false;

	currencyInfo: any;

	currency: any;

	disableUntil: any;

	daySwitcherEnabled: boolean;

	no_prices: boolean;

	@HostListener('window:resize')
	centerScroll(): void {
		try {
			this.daySwitcherContent.nativeElement.scrollIntoView({
				inline: 'center'
			});
		} catch (err) {}
	}

	constructor(private store: Store<fromStore.State>,
		private bookingAvailabilityService: INDRABookingAvailabilityService,
		private currencyService: INDRACurrencyService,
		private dateService: INDRADateService,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private bookingService: BookingService
		) {

		this.daysPrice$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			if (value) {
				this.dailyCosts = value;
			}
		});

		this.bookingSteps$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			if (value) {
				this.bookingSteps = value;

				if (this.dateList.length) {
					const index = this.daysPrice.findIndex(cost => {
						return (
							moment(cost.date).format('DD-MM-YYYY') ===
							moment(this.bookingSteps[this.currentStep]._date).format(
								'DD-MM-YYYY'
							)
						);
					});

					this.selectedEntries[this.currentStep] = this.daysPrice[index];
					this.selectedIndex = index;
				}
			}
		});

		this.bookAwardFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (this.bookAwardFlights != value) {
					this.bookAwardFlights = value;
					this.isLoading = true;
				}

				// if (this.bookAwardFlights) {
				// 	this.hasPrices = false;
				// }
			});

		this.booked_trip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				this.booked_trip = data;
			});

		this.currentStep$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value != this.currentStep) {
					if (this.currentStep != value) {
						this.currentStep = value;
						if (this.bookingSteps[this.currentStep]) {
							this.selectedDate = this.bookingSteps[this.currentStep]._date;
						} else {
							this.selectedDate = new Date();
						}
						if (this.dateList.length != 0) {
							this.INDRA_initializeDays();
						}
					}
				}
			});

		this.listOffers$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(listOffers => {
				this.listOffers = listOffers;
		});

		this.flightFilter$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
			if (value != null) {
				if (this.passengerTypeStudent != value.student) {
					this.passengerTypeStudent = value.student;
				}
			}
		});
		this.daySwitcherEnabled = this.ibeAdminConfigService.getConfigurationValue('bookingSearch.daySwitcherEnabled') === 'true' ? true : false;
		this.no_prices = this.daySwitcherEnabled ? !this.hasPrices : true;

		this.flightInformation$
        .pipe(takeWhile(() => this.isAlive))
        .subscribe(value => {
            if (value) {
                this.flightInformation = value;
            }
        });
	}

	ngOnInit() {
		moment.locale(environment.locale);

		if (this.bookingSteps[this.currentStep].cost != null) {
			this.currency = this.currencyService.INDRA_getCurrencySymbol(this.bookingSteps[this.currentStep].cost.currency.name).unit;
		} else {
			this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;
		}

		if (this.booked_trip.booking_type !== TRIP_TYPE_MULTICITY_CODE) {
			if (this.daysPrice.length == 0) {
				this.INDRA_initializeDays();
			}

			if (this.passengerTypeStudent && this.currentStep == 1) {
				if (this.passengerTypeStudent) {
					if (this.disableUntil) {
						if (moment(this.selectedDate).isBefore(this.disableUntil) || moment(this.selectedDate).format('MM-DD-YYYY') == moment(this.disableUntil).format('MM-DD-YYYY')) {
							const newArrivalDate = this.dateService.INDRA_add(moment(this.bookingSteps[this.currentStep - 1].date).format('YYYY-M-D'), 4, 'days').toDate();
							const newDateIndex = this.daysPrice.findIndex(cost => {
								return (
									moment(newArrivalDate).format('DD-MM-YYYY') ===
									moment(cost.date).format(
										'DD-MM-YYYY'
									)
								);
							});
							this.INDRA_selectEntry(newDateIndex, 1);
						}
					}
				}
			}

			if (this.listOffers && this.listOffers.current_step != this.currentStep) {
				const tempListOffers = _.cloneDeep(this.listOffers);
				tempListOffers.current_step = this.currentStep;

				this.store.dispatch(new ListOffersActions.PutSelectedListOffersAction(tempListOffers));
				this.INDRA_selectEntry(this.selectedIndex, 1);
			}
		}
	}

	ngAfterViewInit() {
		this.centerScroll();
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.dateList) {
			if ((JSON.stringify(changes.dateList.currentValue) != JSON.stringify(changes.dateList.previousValue)) && !changes.dateList.firstChange) {
				this.INDRA_initializeDays();
			}
		}
	}

	INDRA_initializeDays() {
		let index: any = 3;
		const cut = this.dateList[this.currentStep];
		this.daysPrice = [];
		this.prices = [];

		if (this.currentStep == 1 && this.passengerTypeStudent) {
			this.disableUntil = this.dateService.INDRA_add(moment(this.bookingSteps[this.currentStep - 1].date).format('YYYY-M-D'), 3, 'days').toDate();
		}

		cut.forEach(
			cost => {
			if (this.disableUntil) {
				if (moment(cost.date).isSameOrBefore(moment(this.disableUntil))) {
					const dayObject = {
						price: 'No flights',
						date: cost.date
					};
					this.prices.push(null);
					this.daysPrice.push(dayObject);
				} else if (cost.price > 0) {
					const dayObject = {
						price: cost.price + ' ' + (this.bookAwardFlights ? 'M' : this.currency),
						date: cost.date
					};
					this.daysPrice.push(dayObject);
					this.prices.push(cost.price);
				} else {
					const dayObject = {
						price: moment(this.selectedDate).isAfter(moment(cost.date)) ? 'No flights' : 'Sold out',
						date: cost.date
					};
					this.prices.push(null);
					this.daysPrice.push(dayObject);
				}
			} else {
				if (cost.price > 0) {
					const dayObject = {
						price: cost.price + ' ' + (this.bookAwardFlights ? 'M' : this.currency),
						date: cost.date
					};
					this.daysPrice.push(dayObject);
					this.prices.push(cost.price);
				} else {
					const dayObject = {
						price: moment(this.selectedDate).isAfter(moment(cost.date)) ? 'No flights' : 'Sold out',
						date: cost.date
					};
					this.prices.push(null);
					this.daysPrice.push(dayObject);
				}
			}
		});

		index = this.daysPrice.findIndex(
			cost =>
				moment(cost.date).format('DD-MM-YYYY') ===
				moment(this.selectedDate).format('DD-MM-YYYY')
		);

		this.selectedIndex = index;
		this.selectedEntries[this.currentStep] = this.daysPrice[this.selectedIndex];

		if (this.isLoading) {
			this.isLoading = false;
		}
	}

	INDRA_emitPrice() {
		if (this.daysPrice.length != 0) {
			const emitNull = this.daysPrice[this.selectedIndex].date.getDate() == 1;
			this.todayCheapest.emit(emitNull ? null : this.prices[this.selectedIndex]);
		}

	}

	INDRA_printTooltip(entry, index) {
		if (this.checkDate(index)) {
			if (this.currentStep === 0) {
				return this.INDRA_getTranslationKey('dates.text.cantChoosePastDate');
			} else {
				return this.INDRA_getTranslationKey('dates.text.dateBeforeDeparture');
			}
		} else {
			if (this.hasPrices && this.daySwitcherEnabled) {
				if (entry.price === 'Sold out' || entry.price === 'No flights') {
					return this.INDRA_getTranslationKey('dates.text.noFlightsDay');
				} else {
					/*
					return (
						this.INDRA_printFormatedDay(entry.date) +
						'<br>' +
						this.INDRA_printPrice(entry.price)
					);
					*/
					let tooltip = this.INDRA_printFormatedDay(entry.date);
					if (entry.price !== null) {
						tooltip += '<br>' + this.INDRA_printPrice(entry.price) + ' ' + this.INDRA_getTranslationKey('dates.text.perPassenger');
					}
					return tooltip;
				}
			} else {
				if (entry.price === 'Sold out' || entry.price === 'No flights') {
					return this.INDRA_getTranslationKey('dates.text.noFlightsDay');
				} else {
					return null;
				}
			}
		}
	}

	INDRA_printFormatedDay(date: Date) {
		if(date){
			let month = moment(date).format('MMMM');
			if(month){
				month = month.toLowerCase();
				month = this.INDRA_getTranslationKey('dates.text.' + month) !== ('dates.text.' + month) ? this.INDRA_getTranslationKey('dates.text.' + month) : null;
				month = month ? month.substring(0, 3) : null;
			}
			return month ? moment(date).format('DD') + ' ' + month + ' ' + moment(date).format('YYYY') : moment(date).format('DD MMM YYYY');
		}
		return moment(date).format('DD MMM YYYY');
	}

	INDRA_printDay(date: Date) {
		return moment(date).format('D');
	}

	INDRA_printWeekday(date: Date) {
		return moment(date).format('dddd').toLowerCase();
	}

	INDRA_getEntryClasses(index) {
		return {
			'is-selected': this.checkIfSelected(index),
			'no-flights':
				this.daysPrice[index].price === 'No flights' ||
				this.daysPrice[index].price === 'Sold out' ||
				this.checkDate(index)
		};
	}

	private checkDate(index: number): boolean {
		if (this.bookingSteps.length > 1) {
			if (this.currentStep === this.bookingSteps.length - 1) {
				return (
					moment(this.daysPrice[index].date).format('YYYY-MM-DD') < moment(this.bookingSteps[this.currentStep - 1].date).format('YYYY-MM-DD')
				);
			}
			if (this.currentStep === 0) {
				return (
					this.daysPrice[index].date >
					this.bookingSteps[this.currentStep + 1].date
				);
			}
			return false;
		} else {
			return false;
		}
	}

	private checkIfSelected(index: number): boolean {
		if (this.selectedEntries.length === 0) return false;
		if (!this.selectedEntries[this.currentStep]) return false;
		return (
			moment(this.selectedEntries[this.currentStep]['date']).format(
				'DD-MM-YYYY'
			) === moment(this.daysPrice[index]['date']).format('DD-MM-YYYY')
		);
	}

	INDRA_printEntryAriaLabel(entry, index) {
		const IS_SELECTED_TEXT =
			this.selectedEntries[this.currentStep] === index ? 'Selected day: ' : '';
		return (
			IS_SELECTED_TEXT +
			entry.price +
			' on ' +
			this.INDRA_printFormatedDay(entry.date)
		);
	}

	INDRA_getPriceStyle(price) {
		if (price === null) {
			return null;
		}
		return {
			paddingTop: this.INDRA_getPriceHeight(price) + 'px'
		};
		return '';
	}

	INDRA_getPriceHeight(price) {
		price = parseInt(price, 10);
		const MAX_EXTRA_HEIGHT = 34;
		const MIN_EXTRA_HEIGHT = 8;
		const HIGHEST_PRICE = Math.max.apply(null, this.prices);
		const LOWEST_PRICE = Math.min.apply(null, this.prices);

		return (
			Math.round(
				((price - LOWEST_PRICE) * MAX_EXTRA_HEIGHT) /
					(HIGHEST_PRICE - LOWEST_PRICE)
			) + MIN_EXTRA_HEIGHT
		);
	}

	INDRA_selectEntry(index, event) {
		if (this.INDRA_isDateValid(index, event)) {
			if (!this.checkDate(index)) {
				this.bookingService.clearFooterData();
				const dateParameter = moment(this.daysPrice[index].date).format('DDMMYYYY');
				this.dateChanged.emit(dateParameter);
			}
		}
	}

	INDRA_handleMoveForward() {
		if (this.INDRA_showNextDates()) {
			const index = this.dateList[this.currentStep].findIndex(
				cost =>
					moment(cost.date).format('DD-MM-YYYY') ===
					moment(this.selectedDate).format('DD-MM-YYYY')
			);

			this.INDRA_selectEntry(index + 1, 1);
		}
	}

	INDRA_handleMoveBack() {
		if (this.INDRA_showPreviousDates()) {
			const index = this.dateList[this.currentStep].findIndex(
				cost =>
					moment(cost.date).format('DD-MM-YYYY') ===
					moment(this.selectedDate).format('DD-MM-YYYY')
			);

			this.INDRA_selectEntry(index - 1, 1);
		}
	}

	INDRA_printPrice(price) {
		if (this.bookAwardFlights) {
			const number = parseFloat(price);
			if (!isNaN(number)) {
				return `${(number).toLocaleString('pt')} M`;
			}
		}
		return price;
	}

	INDRA_showNextDates() {
		if (this.isLoading) {
			return false;
		}
		if (this.checkDate(6)) {
			if (this.currentStep === 0) {
				return false;
			}
		}
		return true;
	}

	INDRA_showPreviousDates() {
		const currentDate = moment(new Date()).format('DDMMYYYY');
		const firstIndexDate = moment(this.daysPrice[0].date).format('DDMMYYYY');
		const selectedDate = moment (this.daysPrice[this.selectedIndex].date).format('DDMMYYYY');

		if (this.isLoading) {
			return false;
		} else if (firstIndexDate == currentDate) {
			return false;
		} else if (currentDate == selectedDate) {
			return false;
		} else if (this.checkDate(0)) {
			if (this.currentStep === 1) {
				return false;
			}
		}

		return true;
	}

	INDRA_isDateValid(index, event) {
		/*
			1 - day switcher move forward/backward & initial load
			2 - day switcher dates click
		*/
		const currentDate = moment(new Date());
		const selectedDate = moment(this.daysPrice[index].date);
		const costPerDay = this.dateList[this.currentStep];

		if (selectedDate.isBefore(currentDate)) {
			return false;
		} else if ((this.daysPrice[index].price == 'Sold out' || this.daysPrice[index].price == 'No flights') && event == 2) {
			return false;
		} else if ((!costPerDay[index].available) && event == 2) {
			return false;
		}
		return true;
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}

